import { useEffect } from 'react';

const SUFFIX = 'Abrar Farms';

/** Sets the browser tab title to "<page> · Abrar Farms". `null` leaves the title alone, so a
 * parent can stay out of the way while a child owns it (child effects run first, so a parent
 * that always set a title would overwrite its children's). */
export function usePageTitle(page: string | null): void {
  useEffect(() => {
    if (page === null) return;
    document.title = page ? `${page} · ${SUFFIX}` : `${SUFFIX} — Maps`;
  }, [page]);
}
